module.exports = __webpack_public_path__ + "static/media/door3.a33d66d3.png";